//! Called by : src/App.vue (modal-info) !!! unused - pas encore utilisé !!!

<template>
  <base-modal ref="base-modal" pageId="pge_info" pageClass="infos" modalClass="modal-md" modalDataBack="true" modalDataKey="true">

      <template #header>
        <h4 class="modal-title" id="pge_about_title">{{ $t('modals.info') }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>

      <template #body>
        <div class="text-left" style="font-size: 1.4em;">
          <p class="my-3" v-if="info1" v-html="setMarkdown(info1)"></p>
          <p class="my-3" v-if="info2" v-html="setMarkdown(info2)"></p>
          <p class="my-3" v-if="info3" v-html="setMarkdown(info3)"></p>
          <p class="my-3" v-if="info4" v-html="setMarkdown(info4)"></p>
          <p class="my-3" v-if="info5" v-html="setMarkdown(info5)"></p>
        </div>
      </template>

      <template #footer>
        <button type="submit" class="btn btn-secondary btn-lg btn-block" data-dismiss="modal">
          <span class="oi oi-x mr-2"></span>
          {{ $t('modals.close') }}
        </button>
      </template>

  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal'

export default {
  props: {
    info1: String,
    info2: String,
    info3: String,
    info4: String,
    info5: String,
  },
  data() {
      return {
          answer: '',
      }
  },
  methods: {
    setMarkdown(sText) {
      return f_setMarkdown_s(sText);
    }
  },
  components: {
    BaseModal,
  },
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/misc/ModalInfo.vue